import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import UserForm from '../../../components/masters/users/users/UserForm';
import UserTable from '../../../components/masters/users/users/UserTable';
import { fetchUsers, addUser, updateUser, deleteUser, setEditingUser, clearEditingUser } from '../../../redux/actions/masters/users/user/userAction';
import { fetchRoles } from '../../../redux/actions/masters/users/role/roleAction';
import { fetchCompanies } from '../../../redux/actions/masters/company/companyAction';
import { showConfirm } from '../../../utills/sweetAlert';

const outerWrapper = {
  padding: 0,
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  background: 'transparent',
  marginTop: 24,
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};

const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 320,
  flex: 1,
  minHeight: 520,
};

const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginRight: 0,
};
const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginLeft: 0,
};

const responsiveStyle = `
@media (max-width: 900px) {
  .user-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .user-form, .user-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const Users = () => {
  const dispatch = useDispatch();
  const { list, loading, error, editingUser } = useSelector((state) => state.users);
  const { list: roles } = useSelector((state) => state.roles);
  const companies = useSelector((state) => state.company.list);
  const activeCompanies = companies.filter(c => c.trash === 0);
  const [formSuccess, setFormSuccess] = useState('');
  const [formError, setFormError] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
  const [formResetKey, setFormResetKey] = useState(0);

  useEffect(() => {
    dispatch(fetchUsers());
    dispatch(fetchRoles());
    dispatch(fetchCompanies());
  }, [dispatch]);

  const handleAddOrUpdate = async (user) => {
    setFormSuccess('');
    setFormError('');
    setFieldErrors({});
    let errorMsg = null;
    if (editingUser) {
      errorMsg = await dispatch(updateUser({ id: editingUser.user_id, user }));
      dispatch(clearEditingUser());
      dispatch(fetchUsers());
      if (!errorMsg) {
        setFormSuccess('User updated successfully!');
      }
    } else {
      errorMsg = await dispatch(addUser(user));
      dispatch(fetchUsers());
      if (!errorMsg) {
        setFormSuccess('User added successfully!');
      }
    }
    if (errorMsg) {
      setFormError(errorMsg);
      setFormSuccess('');
    }
  };

  const handleEdit = (user) => {
    dispatch(setEditingUser(user));
  };

  const handleDelete = async (id, username) => {
    const confirmed = await showConfirm('Delete User', `Are you sure you want to delete user: ${username}?`, 'Delete', 'Cancel');
    if (confirmed) {
      dispatch(deleteUser(id));
    }
  };

  const handleCancelEdit = () => {
    dispatch(clearEditingUser());
  };

  const handleNew = () => {
    dispatch(clearEditingUser());
    setFormSuccess('');
    setFormError('');
    setFieldErrors({});
    setFormResetKey(k => k + 1);
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={containerStyle} className="user-flex">
        <div style={tableContainer} className="user-table">
          {loading ? (
            <div>Loading...</div>
          ) : error ? (
            <div style={{ color: 'red' }}>{error}</div>
          ) : (
            <UserTable users={list} roles={roles} onEdit={handleEdit} onDelete={handleDelete} onNew={handleNew} />
          )}
        </div>
        <div style={formContainer} className="user-form">
          <UserForm
            key={formResetKey}
            resetKey={formResetKey}
            onSubmit={handleAddOrUpdate}
            editingUser={editingUser}
            onCancel={handleCancelEdit}
            roles={roles}
            users={list}
            formSuccess={formSuccess}
            formError={formError}
            setFormSuccess={setFormSuccess}
            setFormError={setFormError}
            companies={activeCompanies}
            fieldErrors={fieldErrors}
            setFieldErrors={setFieldErrors}
          />
        </div>
      </div>
    </div>
  );
};

export default Users; 